import React, { useState } from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";
import { autoComplete } from "../../services/pappers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import autoCompleteZipCode from "../../services/zipCodes";
import { passwordValidationSchema } from "../../validationSchemas/utilisateur.validation";

const NewPasswordForm = props => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const { password } = props;
  const [allForm, setAllForm] = useState({});

  return (
    <Formik
      initialValues={{
        ...allForm
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};

        const passwordRegex = /(?=.*[0-9])/;
        if (!values.password) {
          errors.password = "Mot de passe nécessaire";
        } else if (values.password.length < 2) {
          errors.password =
            "Votre mot de passe doit faire au moins 2 caractères de long.";
        } else if (!passwordRegex.test(values.password)) {
          errors.password =
            "Votre mot de passe doit contenir au moins un caractère spécial.";
        }

        if (values.password !== values.passwordConfirmation)
          errors.passwordConfirmation =
            "Les deux mots de passe doivent être identiques";

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={passwordValidationSchema}
    >
      {props => {
        const {
          values,
          setFieldValue,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;

        return (
          <form name="newPassword" onSubmit={handleSubmit}>
            <h2>Réinitialiser votre mot de passe</h2>
            <Row>
              <Col xs={6}>
                <label htmlFor="password" className="form-label">
                  Mot de passe
                </label>
                <input
                  name="password"
                  type="password"
                  className={`form-control ${errors.password &&
                    touched.password &&
                    "is-invalid"}`}
                  autoComplete="new-password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <span className="text-muted">
                  Doit contenir au moins un caractère spécial et un chiffre
                </span>

                {errors.password && touched.password && (
                  <div className="invalid-feedback">{errors.password}</div>
                )}
              </Col>
              <Col xs={6}>
                <label htmlFor="passwordConfirmation" className="form-label">
                  Mot de passe (confirmation)
                </label>
                <input
                  name="passwordConfirmation"
                  type="password"
                  className={`form-control ${errors.passwordConfirmation &&
                    touched.passwordConfirmation &&
                    "is-invalid"}`}
                  autoComplete="new-password"
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.passwordConfirmation &&
                  touched.passwordConfirmation && (
                    <div className="invalid-feedback">
                      {errors.passwordConfirmation}
                    </div>
                  )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faCheckCircle} size="sm" />
                  &nbsp; Réinitialiser
                  <div className="btn-cta-overlay"></div>
                </button>
              </Col>{" "}
              <Col xs={12}>
                <hr />
                <span>
                  <a
                    className="callToActionLink"
                    onClick={() => navigate("/login")}
                  >
                    Retour
                  </a>{" "}
                </span>
              </Col>
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default NewPasswordForm;
